const rawDialogs = [
//LESSON 1
[
    {question: "Привіт, як тебе звати?", q_translate: "Hi, what is your name?", answer: "Мене звати Девід.", a_translate: "My name is David."},
    {question: "Звідки ти?", q_translate: "Where are you from?", answer: "Я з Англії.", a_translate: "I am from England."},
    {question: "Скільки тобі років?", q_translate: "How old are you?", answer: "Мені 30 років.", a_translate: "I am 30 years old."},
    {question: "Де ти живеш?", q_translate: "Where do you live?", answer: "Я живу в Лондоні.", a_translate: "I live in London."},
    {question: "Ким ти працюєш?", q_translate: "What do you do?", answer: "Я інженер.", a_translate: "I am an engineer."},
    {question: "Тобі подобається твоя робота?", q_translate: "Do you like your job?", answer: "Так, мені вона дуже подобається.", a_translate: "Yes, I like it very much."},
    {question: "Які в тебе хобі?", q_translate: "What are your hobbies?", answer: "Мені подобається грати у футбол і дивитися фільми.", a_translate: "I like playing football and watching films."},
    {question: "Радий з тобою познайомитись, Девіде!", q_translate: "Nice to meet you, David!", answer: "Також радий познайомитись з тобою, Анно!", a_translate: "Nice to meet you too, Anna!"},
    ],
    
    
    //LESSON 2
[
  {
    question: "О котрій ти прокидаєшся?",
    q_translate: "What time do you wake up?",
    answer: "Я прокидаюся о 7-й ранку.",
    a_translate: "I wake up at 7 a.m."
  },
  {
    question: "Ти снідаєш щодня?",
    q_translate: "Do you eat breakfast every day?",
    answer: "Так, я завжди снідаю.",
    a_translate: "Yes, I always eat breakfast."
  },
  {
    question: "Що ти зазвичай їси на сніданок?",
    q_translate: "What do you usually have for breakfast?",
    answer: "Зазвичай я їм пластівці з молоком.",
    a_translate: "I usually have cereal and milk."
  },
  {
    question: "Як ти добираєшся до школи?",
    q_translate: "How do you go to school?",
    answer: "Я їду до школи автобусом.",
    a_translate: "I go to school by bus."
  },
  {
    question: "О котрій починається твоя школа?",
    q_translate: "What time does your school start?",
    answer: "Вона починається о 8:30 ранку.",
    a_translate: "It starts at 8:30 a.m."
  },
  {
    question: "Що ти робиш після школи?",
    q_translate: "What do you do after school?",
    answer: "Я роблю домашнє завдання.",
    a_translate: "I do my homework."
  },
  {
    question: "Ти допомагаєш вдома?",
    q_translate: "Do you help at home?",
    answer: "Так, я допомагаю мамі готувати вечерю.",
    a_translate: "Yes, I help my mom with dinner."
  },
  {
    question: "О котрій ти лягаєш спати?",
    q_translate: "What time do you go to bed?",
    answer: "Я лягаю спати о 9-й вечора.",
    a_translate: "I go to bed at 9 p.m."
  }
],

    
    
    
    //LESSON 3
[
  {
    question: "Що ти любиш робити у вільний час?",
    q_translate: "What do you like to do in your free time?",
    answer: "Я люблю малювати.",
    a_translate: "I like to draw."
  },
  {
    question: "Ти займаєшся спортом?",
    q_translate: "Do you play any sports?",
    answer: "Так, я граю у футбол.",
    a_translate: "Yes, I play football."
  },
  {
    question: "Тобі подобається читати?",
    q_translate: "Do you like reading?",
    answer: "Так, я читаю кожного вечора.",
    a_translate: "Yes, I read every evening."
  },
  {
    question: "Яке твоє улюблене хобі?",
    q_translate: "What is your favorite hobby?",
    answer: "Моє улюблене хобі — малювання.",
    a_translate: "My favorite hobby is drawing."
  },
  {
    question: "Ти граєш на музичному інструменті?",
    q_translate: "Do you play a musical instrument?",
    answer: "Так, я граю на піаніно.",
    a_translate: "Yes, I play the piano."
  },
  {
    question: "Коли ти зазвичай відпочиваєш?",
    q_translate: "When do you usually relax?",
    answer: "Я відпочиваю після школи.",
    a_translate: "I relax after school."
  },
  {
    question: "Ти любиш дивитися фільми?",
    q_translate: "Do you like watching movies?",
    answer: "Так, особливо комедії.",
    a_translate: "Yes, especially comedies."
  },
  {
    question: "Ти проводиш час з друзями у вихідні?",
    q_translate: "Do you spend time with friends on weekends?",
    answer: "Так, ми граємо разом у парку.",
    a_translate: "Yes, we play together in the park."
  }
],
    
    
    
    //LESSON 4
 [
  {
    question: "Куди ти їздив(-ла) у відпустку?",
    q_translate: "Where did you go on holiday?",
    answer: "Я їздив(-ла) до моря.",
    a_translate: "I went to the sea."
  },
  {
    question: "Тобі подобається подорожувати?",
    q_translate: "Do you like travelling?",
    answer: "Так, дуже подобається.",
    a_translate: "Yes, I like it a lot."
  },
  {
    question: "Яка твоя улюблена країна?",
    q_translate: "What is your favorite country?",
    answer: "Моя улюблена країна — Італія.",
    a_translate: "My favorite country is Italy."
  },
  {
    question: "Коли ти зазвичай подорожуєш?",
    q_translate: "When do you usually travel?",
    answer: "Улітку на канікулах.",
    a_translate: "In the summer during holidays."
  },
  {
    question: "Чим ти подорожуєш?",
    q_translate: "How do you travel?",
    answer: "Ми їздимо машиною.",
    a_translate: "We travel by car."
  },
  {
    question: "Ти був(-ла) за кордоном?",
    q_translate: "Have you been abroad?",
    answer: "Так, один раз.",
    a_translate: "Yes, once."
  },
  {
    question: "Яке місце ти хочеш відвідати?",
    q_translate: "What place do you want to visit?",
    answer: "Я хочу поїхати в Японію.",
    a_translate: "I want to go to Japan."
  },
  {
    question: "З ким ти зазвичай подорожуєш?",
    q_translate: "Who do you usually travel with?",
    answer: "Зі своєю сім’єю.",
    a_translate: "With my family."
  }
],
    
    
    
    //LESSON 5
[
  {
    question: "Яка твоя улюблена їжа?",
    q_translate: "What is your favorite food?",
    answer: "Моя улюблена їжа — піца.",
    a_translate: "My favorite food is pizza."
  },
  {
    question: "Ти вмієш готувати?",
    q_translate: "Can you cook?",
    answer: "Так, я можу приготувати яєчню.",
    a_translate: "Yes, I can cook scrambled eggs."
  },
  {
    question: "Що ти їси на обід?",
    q_translate: "What do you eat for lunch?",
    answer: "Я їм суп та хліб.",
    a_translate: "I eat soup and bread."
  },
  {
    question: "Ти снідаєш щодня?",
    q_translate: "Do you eat breakfast every day?",
    answer: "Так, завжди.",
    a_translate: "Yes, always."
  },
  {
    question: "Ти любиш солодке?",
    q_translate: "Do you like sweets?",
    answer: "Так, особливо шоколад.",
    a_translate: "Yes, especially chocolate."
  },
  {
    question: "Хто готує у вашій родині?",
    q_translate: "Who cooks in your family?",
    answer: "Зазвичай готує мама.",
    a_translate: "My mom usually cooks."
  },
  {
    question: "Ти коли-небудь готував(-ла) торт?",
    q_translate: "Have you ever baked a cake?",
    answer: "Так, з бабусею.",
    a_translate: "Yes, with my grandma."
  },
  {
    question: "Який твій улюблений напій?",
    q_translate: "What is your favorite drink?",
    answer: "Мій улюблений напій — апельсиновий сік.",
    a_translate: "My favorite drink is orange juice."
  }],
    
    
    
    //LESSON 6
[
  {
    question: "Скільки людей у твоїй родині?",
    q_translate: "How many people are in your family?",
    answer: "У моїй родині п’ятеро людей.",
    a_translate: "There are five people in my family."
  },
  {
    question: "У тебе є брати чи сестри?",
    q_translate: "Do you have any brothers or sisters?",
    answer: "Так, у мене є молодший брат.",
    a_translate: "Yes, I have a younger brother."
  },
  {
    question: "Ти часто бачиш своїх друзів?",
    q_translate: "Do you see your friends often?",
    answer: "Так, майже щодня.",
    a_translate: "Yes, almost every day."
  },
  {
    question: "Як звати твого найкращого друга?",
    q_translate: "What is your best friend’s name?",
    answer: "Його звати Артем.",
    a_translate: "His name is Artem."
  },
  {
    question: "Що ви робите з друзями у вихідні?",
    q_translate: "What do you do with your friends on weekends?",
    answer: "Ми граємо в ігри або гуляємо.",
    a_translate: "We play games or go for a walk."
  },
  {
    question: "Ти проводиш час з батьками?",
    q_translate: "Do you spend time with your parents?",
    answer: "Так, ми разом дивимось фільми.",
    a_translate: "Yes, we watch movies together."
  },
  {
    question: "Ти допомагаєш родині вдома?",
    q_translate: "Do you help your family at home?",
    answer: "Так, я прибираю у своїй кімнаті.",
    a_translate: "Yes, I clean my room."
  },
  {
    question: "Ти часто телефонуєш родичам?",
    q_translate: "Do you often call your relatives?",
    answer: "Так, я дзвоню бабусі кожного тижня.",
    a_translate: "Yes, I call my grandma every week."
  }
],
    
    
    
    //LESSON 7
[
  {
    question: "У яку школу ти ходиш?",
    q_translate: "Which school do you go to?",
    answer: "Я навчаюся в 10-й школі.",
    a_translate: "I go to School No. 10."
  },
  {
    question: "Який твій улюблений предмет?",
    q_translate: "What is your favorite subject?",
    answer: "Мені подобається математика.",
    a_translate: "I like math."
  },
  {
    question: "О котрій починаються уроки?",
    q_translate: "What time do your classes start?",
    answer: "О 8:30 ранку.",
    a_translate: "At 8:30 a.m."
  },
  {
    question: "Тобі подобається школа?",
    q_translate: "Do you like school?",
    answer: "Так, мені там цікаво.",
    a_translate: "Yes, I find it interesting."
  },
  {
    question: "Скільки уроків у тебе щодня?",
    q_translate: "How many lessons do you have each day?",
    answer: "Зазвичай шість.",
    a_translate: "Usually six."
  },
  {
    question: "Ти вивчаєш англійську?",
    q_translate: "Do you study English?",
    answer: "Так, ми маємо уроки англійської тричі на тиждень.",
    a_translate: "Yes, we have English lessons three times a week."
  },
  {
    question: "Що ти робиш на перерві?",
    q_translate: "What do you do during breaks?",
    answer: "Я спілкуюсь з друзями.",
    a_translate: "I talk with my friends."
  },
  {
    question: "Тобі задають домашнє завдання?",
    q_translate: "Do you get homework?",
    answer: "Так, майже щодня.",
    a_translate: "Yes, almost every day."
  }
],
    
    
    
    //LESSON 8
[
  {
    question: "Ким ти хочеш стати в майбутньому?",
    q_translate: "What do you want to be in the future?",
    answer: "Я хочу бути лікарем.",
    a_translate: "I want to be a doctor."
  },
  {
    question: "Твої батьки працюють?",
    q_translate: "Do your parents work?",
    answer: "Так, обидва працюють.",
    a_translate: "Yes, both of them work."
  },
  {
    question: "Де працює твій тато?",
    q_translate: "Where does your dad work?",
    answer: "Він працює в офісі.",
    a_translate: "He works in an office."
  },
  {
    question: "Ти хочеш працювати за кордоном?",
    q_translate: "Do you want to work abroad?",
    answer: "Так, це моя мрія.",
    a_translate: "Yes, it’s my dream."
  },
  {
    question: "Тобі подобається допомагати іншим?",
    q_translate: "Do you like helping others?",
    answer: "Так, я люблю допомагати.",
    a_translate: "Yes, I like helping."
  },
  {
    question: "Які навички важливі для роботи?",
    q_translate: "What skills are important for work?",
    answer: "Комунікація і відповідальність.",
    a_translate: "Communication and responsibility."
  },
  {
    question: "Ти коли-небудь мав(-ла) підробіток?",
    q_translate: "Have you ever had a part-time job?",
    answer: "Ні, ще ні.",
    a_translate: "No, not yet."
  },
  {
    question: "Яка твоя ідеальна робота?",
    q_translate: "What is your ideal job?",
    answer: "Робота, де я можу подорожувати.",
    a_translate: "A job where I can travel."
  }
],
    
    
    
    //LESSON 9
[
  {
    question: "Ти любиш ходити по магазинах?",
    q_translate: "Do you like shopping?",
    answer: "Так, дуже люблю.",
    a_translate: "Yes, I love it."
  },
  {
    question: "Що ти купуєш найчастіше?",
    q_translate: "What do you buy most often?",
    answer: "Цукерки та іграшки.",
    a_translate: "Candy and toys."
  },
  {
    question: "У тебе є кишенькові гроші?",
    q_translate: "Do you have pocket money?",
    answer: "Так, я отримую щотижня.",
    a_translate: "Yes, I get it weekly."
  },
  {
    question: "Ти економиш гроші?",
    q_translate: "Do you save money?",
    answer: "Так, я кладу їх у скарбничку.",
    a_translate: "Yes, I put it in a money box."
  },
  {
    question: "Ти коли-небудь купував(-ла) щось онлайн?",
    q_translate: "Have you ever bought anything online?",
    answer: "Так, я замовляв(-ла) книжку.",
    a_translate: "Yes, I ordered a book."
  },
  {
    question: "Який твій улюблений магазин?",
    q_translate: "What is your favorite shop?",
    answer: "Мій улюблений магазин — іграшковий.",
    a_translate: "My favorite shop is the toy store."
  },
  {
    question: "Що ти хочеш купити наступного разу?",
    q_translate: "What do you want to buy next time?",
    answer: "Я хочу нові навушники.",
    a_translate: "I want new headphones."
  },
  {
    question: "Ти ходиш по магазинах самостійно?",
    q_translate: "Do you shop by yourself?",
    answer: "Ні, я ходжу з батьками.",
    a_translate: "No, I go with my parents."
  }
],
    
    
    
    //LESSON 10
[
  {
    question: "Ти користуєшся смартфоном?",
    q_translate: "Do you use a smartphone?",
    answer: "Так, щодня.",
    a_translate: "Yes, every day."
  },
  {
    question: "Які додатки ти використовуєш?",
    q_translate: "What apps do you use?",
    answer: "Instagram і TikTok.",
    a_translate: "Instagram and TikTok."
  },
  {
    question: "Тобі подобається грати в комп’ютерні ігри?",
    q_translate: "Do you like playing computer games?",
    answer: "Так, це весело.",
    a_translate: "Yes, it's fun."
  },
  {
    question: "Скільки часу ти проводиш онлайн?",
    q_translate: "How much time do you spend online?",
    answer: "Приблизно дві години на день.",
    a_translate: "About two hours a day."
  },
  {
    question: "Ти спілкуєшся з друзями онлайн?",
    q_translate: "Do you chat with friends online?",
    answer: "Так, через месенджер.",
    a_translate: "Yes, through messenger."
  },
  {
    question: "Ти робиш фото на телефон?",
    q_translate: "Do you take photos on your phone?",
    answer: "Так, часто.",
    a_translate: "Yes, often."
  },
  {
    question: "Ти користуєшся соціальними мережами?",
    q_translate: "Do you use social media?",
    answer: "Так, майже щодня.",
    a_translate: "Yes, almost every day."
  },
  {
    question: "Занадто багато екранного часу — це добре?",
    q_translate: "Is too much screen time good?",
    answer: "Ні, це шкідливо.",
    a_translate: "No, it’s harmful."
  }
],
    
/// LESSON 11
/// Movies & TV Shows

[
  {"question": "Який твій улюблений фільм?", "q_translate": "What is your favorite movie?", "answer": "Мій улюблений фільм — 'Втеча з Шоушенка'.", "a_translate": "My favorite movie is 'The Shawshank Redemption'."},
  {"question": "Ти дивишся серіали?", "q_translate": "Do you watch TV series?", "answer": "Так, я люблю серіал 'Коронa'.", "a_translate": "Yes, I enjoy the series 'The Crown'."},
  {"question": "Ти ходиш у кінотеатр?", "q_translate": "Do you go to the cinema?", "answer": "Так, кілька разів на місяць.", "a_translate": "Yes, a few times a month."},
  {"question": "Хто твій улюблений актор?", "q_translate": "Who is your favorite actor?", "answer": "Мені подобається Том Хенкс.", "a_translate": "I like Tom Hanks."},
  {"question": "Ти любиш драми чи комедії?", "q_translate": "Do you prefer dramas or comedies?", "answer": "Я віддаю перевагу драмам.", "a_translate": "I prefer dramas."},
  {"question": "Ти дивився останній блокбастер?", "q_translate": "Did you watch the latest blockbuster?", "answer": "Так, це було цікаво.", "a_translate": "Yes, it was interesting."},
  {"question": "Ти дивишся фільми з субтитрами?", "q_translate": "Do you watch movies with subtitles?", "answer": "Іноді, коли це іноземний фільм.", "a_translate": "Sometimes, if it's a foreign film."},
  {"question": "Як часто ти дивишся телевізор?", "q_translate": "How often do you watch TV?", "answer": "Зазвичай увечері після роботи.", "a_translate": "Usually in the evenings after work."}
],

/// LESSON 12
/// Music & Entertainment


[
  {"question": "Яку музику ти слухаєш?", "q_translate": "What kind of music do you listen to?", "answer": "Я слухаю рок і джаз.", "a_translate": "I listen to rock and jazz."},
  {"question": "У тебе є улюблений гурт?", "q_translate": "Do you have a favorite band?", "answer": "Так, мені подобається Coldplay.", "a_translate": "Yes, I like Coldplay."},
  {"question": "Ти коли-небудь був(-ла) на концерті?", "q_translate": "Have you ever been to a concert?", "answer": "Так, кілька разів.", "a_translate": "Yes, a few times."},
  {"question": "Який концерт тобі найбільше сподобався?", "q_translate": "What concert did you enjoy the most?", "answer": "Концерт U2 був неймовірним.", "a_translate": "The U2 concert was incredible."},
  {"question": "Ти слухаєш музику вдома чи в дорозі?", "q_translate": "Do you listen to music at home or on the go?", "answer": "Здебільшого в дорозі.", "a_translate": "Mostly on the go."},
  {"question": "Чи подобається тобі класична музика?", "q_translate": "Do you like classical music?", "answer": "Так, вона дуже розслабляє.", "a_translate": "Yes, it's very relaxing."},
  {"question": "Ти користуєшся стрімінговими сервісами?", "q_translate": "Do you use streaming services?", "answer": "Так, я слухаю Spotify.", "a_translate": "Yes, I use Spotify."},
  {"question": "Що тебе розважає у вільний час?", "q_translate": "What entertains you in your free time?", "answer": "Фільми, музика і книги.", "a_translate": "Movies, music, and books."}
],

/// LESSON 13
/// Sports & Exercise

[
  {"question": "Ти займаєшся спортом регулярно?", "q_translate": "Do you exercise regularly?", "answer": "Так, я тренуюсь тричі на тиждень.", "a_translate": "Yes, I work out three times a week."},
  {"question": "Який твій улюблений вид спорту?", "q_translate": "What is your favorite sport?", "answer": "Мені подобається футбол.", "a_translate": "I like football."},
  {"question": "Ти любиш командні чи індивідуальні види спорту?", "q_translate": "Do you prefer team or individual sports?", "answer": "Командні, вони більш динамічні.", "a_translate": "Team sports, they’re more dynamic."},
  {"question": "Як ти підтримуєш фізичну форму?", "q_translate": "How do you stay in shape?", "answer": "Я ходжу у спортзал.", "a_translate": "I go to the gym."},
  {"question": "Ти дотримуєшся здорового способу життя?", "q_translate": "Do you follow a healthy lifestyle?", "answer": "Так, стараюся правильно харчуватися та багато рухатися.", "a_translate": "Yes, I try to eat well and stay active."},
  {"question": "Який вид фізичної активності тобі не подобається?", "q_translate": "What kind of physical activity do you dislike?", "answer": "Біг — це не моє.", "a_translate": "Running is not for me."},
  {"question": "Ти слідкуєш за спортивними подіями?", "q_translate": "Do you follow sports events?", "answer": "Так, особливо чемпіонати з футболу.", "a_translate": "Yes, especially football championships."},
  {"question": "Ти граєш у якісь ігри з друзями?", "q_translate": "Do you play any games with friends?", "answer": "Іноді граємо в волейбол на вихідних.", "a_translate": "We sometimes play volleyball on weekends."}
],

/// LESSON 14
/// News & Current Events

[
  {"question": "Ти читаєш новини щодня?", "q_translate": "Do you read the news every day?", "answer": "Так, зазвичай вранці.", "a_translate": "Yes, usually in the morning."},
  {"question": "Яке джерело новин ти використовуєш?", "q_translate": "What news source do you use?", "answer": "BBC та місцеві новини онлайн.", "a_translate": "BBC and local online news."},
  {"question": "Тебе цікавить політика?", "q_translate": "Are you interested in politics?", "answer": "Так, але іноді це втомлює.", "a_translate": "Yes, but sometimes it’s exhausting."},
  {"question": "Яка остання новина тебе вразила?", "q_translate": "What recent news surprised you?", "answer": "Новини про кліматичні зміни.", "a_translate": "News about climate change."},
  {"question": "Чи обговорюєш ти новини з друзями?", "q_translate": "Do you discuss news with friends?", "answer": "Так, ми часто ділимося думками.", "a_translate": "Yes, we often share opinions."},
  {"question": "Ти дивишся новини по телевізору?", "q_translate": "Do you watch the news on TV?", "answer": "Іноді, якщо є час.", "a_translate": "Sometimes, if I have time."},
  {"question": "Які теми тебе цікавлять найбільше?", "q_translate": "What topics interest you the most?", "answer": "Наука, економіка і здоров’я.", "a_translate": "Science, economy, and health."},
  {"question": "Чи перевіряєш ти факти перед тим, як поширити новини?", "q_translate": "Do you fact-check before sharing news?", "answer": "Так, це дуже важливо.", "a_translate": "Yes, it’s very important."}
],

/// LESSON 15
/// Dreams & Future Plans

[
  {"question": "Яка твоя найбільша мрія?", "q_translate": "What is your biggest dream?", "answer": "Моя мрія — подорожувати світом.", "a_translate": "My dream is to travel the world."},
  {"question": "Які в тебе плани на майбутнє?", "q_translate": "What are your future plans?", "answer": "Я хочу відкрити власний бізнес.", "a_translate": "I want to start my own business."},
  {"question": "Ти ставиш перед собою цілі?", "q_translate": "Do you set goals for yourself?", "answer": "Так, це допомагає зосередитись.", "a_translate": "Yes, it helps me stay focused."},
  {"question": "Чим ти мрієш займатися через 5 років?", "q_translate": "What do you dream of doing in 5 years?", "answer": "Я хочу працювати в сфері технологій.", "a_translate": "I want to work in tech."},
  {"question": "Ти боїшся змін?", "q_translate": "Are you afraid of change?", "answer": "Ні, я вважаю їх шансом для росту.", "a_translate": "No, I see them as a chance for growth."},
  {"question": "Які у тебе професійні амбіції?", "q_translate": "What are your career ambitions?", "answer": "Я прагну стати менеджером проєктів.", "a_translate": "I aim to become a project manager."},
  {"question": "Ти віриш у досягнення своїх мрій?", "q_translate": "Do you believe in achieving your dreams?", "answer": "Так, якщо наполегливо працювати.", "a_translate": "Yes, with hard work."},
  {"question": "Що тебе мотивує?", "q_translate": "What motivates you?", "answer": "Моя сім’я і бажання самореалізації.", "a_translate": "My family and the desire for self-realization."}
],

//LESSON 16
///Cultural Differences – Discuss traditions, customs, and cultural experiences.

[
  {"question": "Яке твоє улюблене свято?", "q_translate": "What is your favorite holiday?", "answer": "Я люблю Різдво.", "a_translate": "I love Christmas."},
  {"question": "Чи був ти в іншій країні?", "q_translate": "Have you been to another country?", "answer": "Так, я був у Польщі.", "a_translate": "Yes, I’ve been to Poland."},
  {"question": "Чи у вас є традиції в родині?", "q_translate": "Do you have family traditions?", "answer": "Так, ми разом святкуємо Пасху.", "a_translate": "Yes, we celebrate Easter together."},
  {"question": "Яку культуру ти хочеш дізнатися?", "q_translate": "What culture do you want to learn about?", "answer": "Мені цікава японська культура.", "a_translate": "I’m interested in Japanese culture."},
  {"question": "Чи пробував ти іншу кухню?", "q_translate": "Have you tried other food?", "answer": "Так, я люблю італійську їжу.", "a_translate": "Yes, I love Italian food."},
  {"question": "Що ти знаєш про інші культури?", "q_translate": "What do you know about other cultures?", "answer": "У різних країнах різні звичаї.", "a_translate": "Different countries have different customs."},
  {"question": "Чи важливо знати про інші культури?", "q_translate": "Is it important to know about other cultures?", "answer": "Так, це допомагає розуміти людей.", "a_translate": "Yes, it helps to understand people."},
  {"question": "Чи є різниця між культурами?", "q_translate": "Are there differences between cultures?", "answer": "Так, у кожної культури свої традиції.", "a_translate": "Yes, each culture has its own traditions."}
],

//LESSON 17
//Weather & Seasons – Talk about favorite seasons and how weather affects daily life.

[
  {"question": "Яка твоя улюблена пора року?", "q_translate": "What is your favorite season?", "answer": "Мені подобається літо.", "a_translate": "I like summer."},
  {"question": "Яка сьогодні погода?", "q_translate": "What’s the weather like today?", "answer": "Сонячно і тепло.", "a_translate": "It’s sunny and warm."},
  {"question": "Чи любиш ти сніг?", "q_translate": "Do you like snow?", "answer": "Так, люблю гуляти, коли сніжить.", "a_translate": "Yes, I like walking when it snows."},
  {"question": "Що ти робиш у дощ?", "q_translate": "What do you do in the rain?", "answer": "Я залишаюсь вдома і п’ю чай.", "a_translate": "I stay home and drink tea."},
  {"question": "Чи любиш дощову погоду?", "q_translate": "Do you like rainy weather?", "answer": "Не дуже, вона сумна.", "a_translate": "Not really, it’s sad."},
  {"question": "Чи змінюється твій день влітку?", "q_translate": "Does your day change in summer?", "answer": "Так, я більше гуляю.", "a_translate": "Yes, I walk more."},
  {"question": "Яка погода тобі подобається?", "q_translate": "What weather do you like?", "answer": "Мені подобається тепло і сонце.", "a_translate": "I like warm and sunny weather."},
  {"question": "Як ти готуєшся до зими?", "q_translate": "How do you prepare for winter?", "answer": "Я ношу теплий одяг.", "a_translate": "I wear warm clothes."}
],

//LESSON 18
//Health & Wellness (Simplified)

[
  {"question": "Як ти дбаєш про своє здоров'я?", "q_translate": "How do you take care of your health?", "answer": "Я їм багато овочів і п’ю воду.", "a_translate": "I eat lots of vegetables and drink water."},
  {"question": "Чи займаєшся спортом?", "q_translate": "Do you do sports?", "answer": "Так, я ходжу в спортзал тричі на тиждень.", "a_translate": "Yes, I go to the gym three times a week."},
  {"question": "Як ти борешся зі стресом?", "q_translate": "How do you deal with stress?", "answer": "Я слухаю музику і медитую.", "a_translate": "I listen to music and meditate."},
  {"question": "Скільки годин ти спиш щоночі?", "q_translate": "How many hours do you sleep each night?", "answer": "Я сплю близько восьми годин.", "a_translate": "I sleep about eight hours."},
  {"question": "Чи любиш ти ходити на прогулянки?", "q_translate": "Do you like walking?", "answer": "Так, це допомагає мені розслабитись.", "a_translate": "Yes, it helps me relax."},
  {"question": "Що ти робиш, коли почуваєшся втомленим?", "q_translate": "What do you do when you feel tired?", "answer": "Я відпочиваю і п’ю чай.", "a_translate": "I rest and drink tea."},
  {"question": "Чи їсиш ти здорову їжу?", "q_translate": "Do you eat healthy food?", "answer": "Так, я стараюсь уникати фастфуду.", "a_translate": "Yes, I try to avoid fast food."},
  {"question": "Як ти підтримуєш гарний настрій?", "q_translate": "How do you keep a good mood?", "answer": "Я спілкуюсь з друзями і займаюсь хобі.", "a_translate": "I talk to friends and do hobbies."}
],


//LESSON 19
//Personal Experiences & Stories (Simplified)
[
  {"question": "Розкажи про цікавий випадок з твого життя.", "q_translate": "Tell me an interesting event from your life.", "answer": "Одного разу я загубився в новому місті.", "a_translate": "Once, I got lost in a new city."},
  {"question": "Чи траплялися з тобою смішні ситуації?", "q_translate": "Have you had funny situations?", "answer": "Так, я впав на вулиці і всі сміялись.", "a_translate": "Yes, I fell on the street and everyone laughed."},
  {"question": "Розкажи про твою найкращу поїздку.", "q_translate": "Tell me about your best trip.", "answer": "Я їздив до моря з друзями.", "a_translate": "I went to the sea with friends."},
  {"question": "Чи допомагав ти комусь колись?", "q_translate": "Have you ever helped someone?", "answer": "Так, я допоміг сусіду з ремонтом.", "a_translate": "Yes, I helped my neighbor with repairs."},
  {"question": "Який твій найщасливіший спогад?", "q_translate": "What is your happiest memory?", "answer": "Коли я отримав першу роботу.", "a_translate": "When I got my first job."},
  {"question": "Розкажи про свій день народження.", "q_translate": "Tell me about your birthday.", "answer": "Ми святкували з сім'єю і друзями.", "a_translate": "We celebrated with family and friends."},
  {"question": "Чи було у тебе цікаве хобі?", "q_translate": "Have you had an interesting hobby?", "answer": "Так, я колись грав на гітарі.", "a_translate": "Yes, I used to play guitar."},
  {"question": "Розкажи про свій улюблений фільм.", "q_translate": "Tell me about your favorite movie.", "answer": "Мій улюблений фільм — комедія.", "a_translate": "My favorite movie is a comedy."}
],


//LESSON 20
// If You Could... (Simplified)
[
  {"question": "Якби ти міг поїхати куди завгодно, куди б ти поїхав?", "q_translate": "If you could travel anywhere, where would you go?", "answer": "Я б поїхав до Парижа.", "a_translate": "I would go to Paris."},
  {"question": "Якби ти міг мати будь-яку роботу, яку б обрав?", "q_translate": "If you could have any job, what would you choose?", "answer": "Я б хотів бути вчителем.", "a_translate": "I would like to be a teacher."},
  {"question": "Якби ти міг жити в іншій країні, де б ти жив?", "q_translate": "If you could live in another country, where would you live?", "answer": "Я б жив у Італії.", "a_translate": "I would live in Italy."},
  {"question": "Якби ти міг змінити щось у світі, що б це було?", "q_translate": "If you could change something in the world, what would it be?", "answer": "Я б хотів, щоб не було війни.", "a_translate": "I would want there to be no war."},
  {"question": "Якби ти міг зустріти відому людину, кого б ти вибрав?", "q_translate": "If you could meet a famous person, who would you choose?", "answer": "Я б зустрів Білла Гейтса.", "a_translate": "I would meet Bill Gates."},
  {"question": "Якби ти міг мати суперсилу, яку б обрав?", "q_translate": "If you could have a superpower, which one would you choose?", "answer": "Я б хотів літати.", "a_translate": "I would like to fly."},
  {"question": "Якби ти міг їсти тільки одну страву, що б це було?", "q_translate": "If you could eat only one dish, what would it be?", "answer": "Я б обрав піцу.", "a_translate": "I would choose pizza."},
  {"question": "Якби ти міг вивчити будь-яку мову, яку б вибрав?", "q_translate": "If you could learn any language, which one would you choose?", "answer": "Я б хотів вивчити іспанську.", "a_translate": "I would like to learn Spanish."}
],


//LESSON 21
//Books & Reading (Simplified)
[
  {"question": "Яка твоя улюблена книга?", "q_translate": "What is your favorite book?", "answer": "Моя улюблена книга — казки.", "a_translate": "My favorite book is fairy tales."},
  {"question": "Ти любиш читати?", "q_translate": "Do you like to read?", "answer": "Так, я читаю кожен день.", "a_translate": "Yes, I read every day."},
  {"question": "Хто твій улюблений автор?", "q_translate": "Who is your favorite author?", "answer": "Мій улюблений автор — Толстой.", "a_translate": "My favorite author is Tolstoy."},
  {"question": "Яку книгу ти недавно читав?", "q_translate": "What book did you read recently?", "answer": "Я читав детектив.", "a_translate": "I read a detective story."},
  {"question": "Ти читаєш книги в електронному вигляді?", "q_translate": "Do you read e-books?", "answer": "Іноді, мені подобається.", "a_translate": "Sometimes, I like it."},
  {"question": "Яку книгу ти хочеш прочитати?", "q_translate": "What book do you want to read?", "answer": "Я хочу прочитати роман.", "a_translate": "I want to read a novel."},
  {"question": "Ти читаєш газети чи журнали?", "q_translate": "Do you read newspapers or magazines?", "answer": "Я читаю журнали.", "a_translate": "I read magazines."},
  {"question": "Чи любиш ти аудіокниги?", "q_translate": "Do you like audiobooks?", "answer": "Так, я слухаю їх в машині.", "a_translate": "Yes, I listen to them in the car."}
],


//LESSON 22
//Pets & Animals (Simplified)
[
  {"question": "Чи є у тебе домашні тварини?", "q_translate": "Do you have pets?", "answer": "Так, у мене є кіт.", "a_translate": "Yes, I have a cat."},
  {"question": "Яка твоя улюблена тварина?", "q_translate": "What is your favorite animal?", "answer": "Мій улюблений — собака.", "a_translate": "My favorite is a dog."},
  {"question": "Ти любиш тварин?", "q_translate": "Do you like animals?", "answer": "Так, я їх дуже люблю.", "a_translate": "Yes, I love them very much."},
  {"question": "Чи коли-небудь ти бачив диких тварин?", "q_translate": "Have you ever seen wild animals?", "answer": "Так, я бачив оленя в лісі.", "a_translate": "Yes, I saw a deer in the forest."},
  {"question": "Як ти піклуєшся про свого пса?", "q_translate": "How do you take care of your dog?", "answer": "Я гуляю з ним кожен день.", "a_translate": "I walk with him every day."},
  {"question": "Чи хочеш ти завести тварину?", "q_translate": "Do you want to get a pet?", "answer": "Так, я хочу кота.", "a_translate": "Yes, I want a cat."},
  {"question": "Ти боїшся великих тварин?", "q_translate": "Are you afraid of big animals?", "answer": "Ні, я не боюсь.", "a_translate": "No, I’m not afraid."},
  {"question": "Яка тварина живе у твоєму місті?", "q_translate": "What animals live in your city?", "answer": "У місті багато голубів.", "a_translate": "There are many pigeons in the city."}
],


//LESSON 23
//Environment & Nature (Simplified)
[
  {"question": "Ти любиш природу?", "q_translate": "Do you like nature?", "answer": "Так, дуже люблю.", "a_translate": "Yes, I like it very much."},
  {"question": "Чи ходиш ти на прогулянки в лісі?", "q_translate": "Do you go for walks in the forest?", "answer": "Так, іноді ходжу.", "a_translate": "Yes, I go sometimes."},
  {"question": "Що ти робиш для захисту природи?", "q_translate": "What do you do to protect nature?", "answer": "Я сортують сміття.", "a_translate": "I sort garbage."},
  {"question": "Чи турбує тебе забруднення?", "q_translate": "Are you worried about pollution?", "answer": "Так, це велика проблема.", "a_translate": "Yes, it is a big problem."},
  {"question": "Ти любиш зелені парки?", "q_translate": "Do you like green parks?", "answer": "Так, вони дуже гарні.", "a_translate": "Yes, they are very nice."},
  {"question": "Чи купуєш ти екологічні продукти?", "q_translate": "Do you buy eco-friendly products?", "answer": "Іноді, коли можу.", "a_translate": "Sometimes, when I can."},
  {"question": "Які тварини живуть у природі поблизу тебе?", "q_translate": "What animals live near you in nature?", "answer": "Тут є птахи і білки.", "a_translate": "There are birds and squirrels here."},
  {"question": "Чи зберігаєш ти воду вдома?", "q_translate": "Do you save water at home?", "answer": "Так, я не залишаю воду відкритою.", "a_translate": "Yes, I don’t leave water running."}
],

//LESSON 24
//Hometown & Neighborhood (Simplified)
[
  {"question": "Де ти живеш?", "q_translate": "Where do you live?", "answer": "Я живу у Києві.", "a_translate": "I live in Kyiv."},
  {"question": "Ти любиш своє місто?", "q_translate": "Do you like your city?", "answer": "Так, моє місто красиве.", "a_translate": "Yes, my city is beautiful."},
  {"question": "Опиши свій район.", "q_translate": "Describe your neighborhood.", "answer": "У нас багато парків і кафе.", "a_translate": "We have many parks and cafes."},
  {"question": "Де ти народився?", "q_translate": "Where were you born?", "answer": "Я народився в Харкові.", "a_translate": "I was born in Kharkiv."},
  {"question": "Чи змінився твій район?", "q_translate": "Has your neighborhood changed?", "answer": "Так, побудували нові будинки.", "a_translate": "Yes, they built new buildings."},
  {"question": "Що тобі подобається в твоєму місті?", "q_translate": "What do you like about your city?", "answer": "Мені подобається зелена зона.", "a_translate": "I like the green area."},
  {"question": "Чи є у вас ринок поруч?", "q_translate": "Is there a market near you?", "answer": "Так, є великий ринок.", "a_translate": "Yes, there is a big market."},
  {"question": "Як ти добираєшся на роботу?", "q_translate": "How do you get to work?", "answer": "Я їжджу автобусом.", "a_translate": "I go by bus."}
],


//LESSON 25
//Languages & Communication (Simplified)
[
  {"question": "Які мови ти знаєш?", "q_translate": "What languages do you know?", "answer": "Я знаю українську і російську.", "a_translate": "I know Ukrainian and Russian."},
  {"question": "Чи хочеш вивчити нову мову?", "q_translate": "Do you want to learn a new language?", "answer": "Так, я хочу вивчити англійську.", "a_translate": "Yes, I want to learn English."},
  {"question": "Чи важко вчити мови?", "q_translate": "Is it hard to learn languages?", "answer": "Іноді, але цікаво.", "a_translate": "Sometimes, but it’s interesting."},
  {"question": "Чи спілкуєшся ти з іноземцями?", "q_translate": "Do you talk with foreigners?", "answer": "Так, я розмовляю з туристами.", "a_translate": "Yes, I talk with tourists."},
  {"question": "Яка твоя рідна мова?", "q_translate": "What is your native language?", "answer": "Моя рідна мова — українська.", "a_translate": "My native language is Ukrainian."},
  {"question": "Чи допомагає тобі мова у роботі?", "q_translate": "Does language help you at work?", "answer": "Так, англійська дуже корисна.", "a_translate": "Yes, English is very useful."},
  {"question": "Чи пробував ти вивчати мову онлайн?", "q_translate": "Have you tried learning a language online?", "answer": "Так, я користуюсь додатками.", "a_translate": "Yes, I use apps."},
  {"question": "Чи легко тобі спілкуватися з іншими?", "q_translate": "Is it easy for you to communicate with others?", "answer": "Так, я стараюсь говорити просто.", "a_translate": "Yes, I try to speak simply."}
],


//LESSON 26
// Fashion & Style (Simplified)

[
  {"question": "Який твій улюблений стиль одягу?", "q_translate": "What is your favorite clothing style?", "answer": "Я люблю простий і зручний стиль.", "a_translate": "I like simple and comfortable style."},
  {"question": "Ти слідкуєш за модою?", "q_translate": "Do you follow fashion?", "answer": "Іноді дивлюсь нові тренди.", "a_translate": "Sometimes I watch new trends."},
  {"question": "Який колір ти любиш носити?", "q_translate": "What color do you like to wear?", "answer": "Я люблю синій колір.", "a_translate": "I like blue color."},
  {"question": "Де ти купуєш одяг?", "q_translate": "Where do you buy clothes?", "answer": "Я купую в магазині поруч.", "a_translate": "I buy at a nearby store."},
  {"question": "Чи подобається тобі одягати капелюх?", "q_translate": "Do you like wearing hats?", "answer": "Так, особливо взимку.", "a_translate": "Yes, especially in winter."},
  {"question": "Ти носиш більше штани чи сукні?", "q_translate": "Do you wear pants or dresses more?", "answer": "Я часто ношу штани.", "a_translate": "I often wear pants."},
  {"question": "Які аксесуари ти любиш?", "q_translate": "What accessories do you like?", "answer": "Мені подобаються годинники.", "a_translate": "I like watches."},
  {"question": "Чи важливо для тебе бути модним?", "q_translate": "Is it important for you to be fashionable?", "answer": "Ні, мені важливо бути комфортним.", "a_translate": "No, being comfortable is important to me."}
],


//LESSON 27
// Celebrations & Festivals (Simplified)

[
  {"question": "Яке твоє улюблене свято?", "q_translate": "What is your favorite holiday?", "answer": "Моє улюблене свято — Різдво.", "a_translate": "My favorite holiday is Christmas."},
  {"question": "Як ти святкуєш свій день народження?", "q_translate": "How do you celebrate your birthday?", "answer": "Я святкую з родиною.", "a_translate": "I celebrate with family."},
  {"question": "Чи подобаються тобі фестивалі?", "q_translate": "Do you like festivals?", "answer": "Так, я люблю фестивалі музики.", "a_translate": "Yes, I like music festivals."},
  {"question": "Які традиції є у вашій родині?", "q_translate": "What traditions does your family have?", "answer": "Ми готуємо святкову вечерю.", "a_translate": "We cook a holiday dinner."},
  {"question": "Чи даруєш ти подарунки на свята?", "q_translate": "Do you give gifts on holidays?", "answer": "Так, я люблю дарувати подарунки.", "a_translate": "Yes, I like giving gifts."},
  {"question": "Який твій улюблений національний святковий день?", "q_translate": "What is your favorite national holiday?", "answer": "Мені подобається День Незалежності.", "a_translate": "I like Independence Day."},
  {"question": "Чи любиш ти святкові салюти?", "q_translate": "Do you like fireworks?", "answer": "Так, вони дуже гарні.", "a_translate": "Yes, they are very beautiful."},
  {"question": "Як ти готуєшся до свят?", "q_translate": "How do you prepare for holidays?", "answer": "Я прикрашаю дім і купую подарунки.", "a_translate": "I decorate the house and buy gifts."}
],


//LESSON 28
// Art & Creativity (Simplified)
[
  {"question": "Ти любиш малювати?", "q_translate": "Do you like to draw?", "answer": "Так, я малюю у вільний час.", "a_translate": "Yes, I draw in my free time."},
  {"question": "Чи пробував ти робити творчі проєкти?", "q_translate": "Have you tried creative projects?", "answer": "Так, я робив колажі.", "a_translate": "Yes, I made collages."},
  {"question": "Який твій улюблений вид мистецтва?", "q_translate": "What is your favorite kind of art?", "answer": "Мені подобається живопис.", "a_translate": "I like painting."},
  {"question": "Чи відвідуєш ти музеї?", "q_translate": "Do you visit museums?", "answer": "Іноді ходжу з друзями.", "a_translate": "Sometimes I go with friends."},
  {"question": "Ти любиш фотографувати?", "q_translate": "Do you like taking photos?", "answer": "Так, я фотографую природу.", "a_translate": "Yes, I take photos of nature."},
  {"question": "Чи є у тебе хобі, пов’язане з мистецтвом?", "q_translate": "Do you have an art-related hobby?", "answer": "Так, я роблю вироби з паперу.", "a_translate": "Yes, I do paper crafts."},
  {"question": "Ти хочеш вчитися малювати краще?", "q_translate": "Do you want to learn to draw better?", "answer": "Так, я хочу ходити на уроки.", "a_translate": "Yes, I want to take lessons."},
  {"question": "Який твій улюблений колір?", "q_translate": "What is your favorite color?", "answer": "Мій улюблений колір — зелений.", "a_translate": "My favorite color is green."}
],


//LESSON 29
//Transportation & Commuting (Simplified)
[
  {"question": "Як ти їдеш на роботу?", "q_translate": "How do you get to work?", "answer": "Я їжджу автобусом.", "a_translate": "I go by bus."},
  {"question": "Скільки часу займає дорога?", "q_translate": "How long is your commute?", "answer": "Приблизно 30 хвилин.", "a_translate": "About 30 minutes."},
  {"question": "Чи подобається тобі користуватися метро?", "q_translate": "Do you like using the subway?", "answer": "Так, це швидко.", "a_translate": "Yes, it’s fast."},
  {"question": "Чи ти коли-небудь їздив на велосипеді?", "q_translate": "Have you ever ridden a bike?", "answer": "Так, я часто їжджу на велосипеді.", "a_translate": "Yes, I often ride a bike."},
  {"question": "Чи любиш ти подорожувати?", "q_translate": "Do you like to travel?", "answer": "Так, я люблю подорожі.", "a_translate": "Yes, I like traveling."},
  {"question": "Який твій улюблений вид транспорту?", "q_translate": "What is your favorite transport?", "answer": "Мені подобається поїзд.", "a_translate": "I like the train."},
  {"question": "Чи є у тебе машина?", "q_translate": "Do you have a car?", "answer": "Ні, я користуюся громадським транспортом.", "a_translate": "No, I use public transport."},
  {"question": "Ти коли-небудь літав літаком?", "q_translate": "Have you ever flown on a plane?", "answer": "Так, я літав минулого року.", "a_translate": "Yes, I flew last year."}
],



//LESSON 30
//Challenges & Achievements (Simplified)

[
  {"question": "Який твій найбільший успіх?", "q_translate": "What is your biggest achievement?", "answer": "Я закінчив університет.", "a_translate": "I finished university."},
  {"question": "Чи було тобі важко вчитися?", "q_translate": "Was it hard for you to study?", "answer": "Так, іноді було складно.", "a_translate": "Yes, sometimes it was difficult."},
  {"question": "Яку мету ти досяг цього року?", "q_translate": "What goal did you reach this year?", "answer": "Я навчився готувати нову страву.", "a_translate": "I learned to cook a new dish."},
  {"question": "Чи мав ти великі проблеми?", "q_translate": "Have you had big problems?", "answer": "Так, але я їх подолав.", "a_translate": "Yes, but I overcame them."},
  {"question": "Що ти робиш, коли виникають труднощі?", "q_translate": "What do you do when you have difficulties?", "answer": "Я прошу допомоги.", "a_translate": "I ask for help."},
  {"question": "Яке досягнення ти хочеш отримати?", "q_translate": "What achievement do you want to get?", "answer": "Я хочу вивчити іноземну мову.", "a_translate": "I want to learn a foreign language."},
  {"question": "Чи пишаєшся ти собою?", "q_translate": "Are you proud of yourself?", "answer": "Так, я пишаюся своїми успіхами.", "a_translate": "Yes, I am proud of my achievements."},
  {"question": "Як ти святкуєш свої успіхи?", "q_translate": "How do you celebrate your successes?", "answer": "Я зустрічаюсь з друзями.", "a_translate": "I meet with friends."}
]

    
]

const dialogs = rawDialogs.map((value, index) => (
        value.map(val => (
          {
            id: index+1,
            lesson: index+1,
            question: val.question,
            q_translate: val.q_translate,
            q_display: "none",
            answer: val.answer,
            a_translate: val.a_translate,
            a_display: "none"
          }
        ))
))


const DialogsData = dialogs.map((dialog, index) => (
    {
        id: index+1,
        lesson: index+1,
        dialog,
    }
))

export { dialogs, DialogsData }


